<div class="bmc-working-time-schema-detail">
  <div class="bmc-working-time-schema-detail__user bz-space--stack-m">
    <div class="bmc-working-time-schema-detail__section bz-space--inline-m bz-space--stack-s">
      <strong
        class="bz-space--stack-xs bmc-working-time-schema-detail__label">{{'USER_GROUPS_BY_USER.SEARCH_USER_BY' | translate}}</strong>
      <bzg-select [placeholder]="'USER_GROUPS_BY_USER.SELECT_A_CATEGORY' | translate"
        [(value)]="selectedFilterColumn">
        <bzg-option *ngFor="let filterColumn of (filterColumns$ | async)" [value]="filterColumn">
          {{ filterColumnsResources[filterColumn] | translate }}</bzg-option>
      </bzg-select>
    </div>
    <div class="bmc-working-time-schema-detail__section bz-space--inline-m">
      <strong
        class="bz-space--stack-xs bmc-working-time-schema-detail__label">{{'USER_GROUPS_BY_USER.SEARCH_USER' | translate}}</strong>
      <bzg-autocomplete #autocompleteUser [placeholder]="'USER_GROUPS_BY_USER.SEARCH_AN_USER_TO_ADD' | translate" [optionSize]="'medium'"
        (valueChange)="filter($event)" (optionSelected)="userSelected($event)" [displayWith]="displayFn">
        <bzg-option *ngFor="let userAutocomplete of (autocompleteUsers$ | async)" [value]="userAutocomplete">
          <ng-container *ngIf="!(isLoadingUsers$ | async)  && (autocompleteUsers$ | async).length > 0">
            <div class="bz-initials bz-space--inline-s">{{ userAutocomplete.fullName.trim().charAt(0).toUpperCase() }}
            </div>
            <div class="bz-option__info">
              <span class="bz-option__title">{{ userAutocomplete.fullName }}</span>
            </div>
          </ng-container>
          <ng-container *ngIf="!(isLoadingUsers$ | async) && (autocompleteUsers$ | async).length === 0">
            <div class="bz-option__info">
              <span class="bz-option__title">{{ 'USER_GROUPS.FILTER_NO_RESULTS' | translate }}</span>
            </div>
          </ng-container>
          <ng-container *ngIf="(isLoadingUsers$ | async)">
            <div class="bz-option__info">
              <span class="bz-option__title">{{ 'USER_GROUPS.FILTER_USERS_LOADING' | translate }}</span>
            </div>
          </ng-container>
        </bzg-option>
      </bzg-autocomplete>
    </div>
  </div>
  <div class="bmc-working-time-schema-detail__base-calendar bz-space--stack-xl">
    <strong
      class="bz-space--stack-xs bmc-working-time-schema-detail__label">{{'WORKING_TIME_SCHEMA.BASE_CALENDAR' | translate}}</strong>
    <bzg-select [placeholder]="'USER_GROUPS_BY_USER.SELECT_A_CATEGORY' | translate" [(ngModel)]="selectedBaseCalendar" [(value)]="selectedBaseCalendar"
      [disabled]="!selectedUser">
      <bzg-option *ngIf="selectedBaseCalendar === -1" [value]="-1">{{'GLOBAL.NONE' | translate}}</bzg-option>
      <bzg-option *ngFor="let baseCalendar of baseCalendars" [value]="baseCalendar.idWorkingTimeSchema"
        (selectionChanged)="onBaseCalendarChanged(baseCalendar)">{{baseCalendar.wtsName}}
      </bzg-option>
    </bzg-select>
  </div>
  <div class="bmc-working-time-schema-detail-legends bz-space--stack-m">
    <strong class="bmc-working-time-schema-detail__label bz-space--stack-s">
      {{'WORKING_TIME_SCHEMA.LEGEND' | translate}}
    </strong>
    <ul class="bmc-working-time-schema-detail-legends__list">
      <li class="bmc-working-time-schema-detail-legends__item bz-space--inline-m bz-space--stack-s">
        <div
          class="bz-color-bg--neutral-100 bmc-working-time-schema-detail-legends__leyend-working bmc-working-time-schema-detail-legends__leyend bz-space--inline-s">
        </div>
        <label class="bz-font-size--body-small">{{'WORKING_TIME_SCHEMA.LEYEND_WORKING' | translate}}</label>
      </li>
      <li class="bmc-working-time-schema-detail-legends__item bz-space--inline-m bz-space--stack-s">
        <div class="bz-color-bg--theme-600 bmc-working-time-schema-detail-legends__leyend bz-space--inline-s"></div>
        <label class="bz-font-size--body-small">{{'WORKING_TIME_SCHEMA.LEYEND_NONWORKING' | translate}}</label>
      </li>
      <li class="bmc-working-time-schema-detail-legends__item bz-space--inline-m bz-space--stack-s">
        <div
          class="bmc-working-time-schema-detail-legends--green bmc-working-time-schema-detail-legends__leyend bz-space--inline-s">
        </div>
        <label class="bz-font-size--body-small">{{'WORKING_TIME_SCHEMA.LEYEND_EDITED_DAYS' | translate}}</label>
      </li>
      <li class="bmc-working-time-schema-detail-legends__item bz-space--inline-m bz-space--stack-s">
        <div class="bz-color-bg--theme-200 bmc-working-time-schema-detail-legends__leyend bz-space--inline-s"></div>
        <label class="bz-font-size--body-small">{{'WORKING_TIME_SCHEMA.LEYEND_EDITED_HOURS' | translate}}</label>
      </li>
    </ul>
  </div>
</div>
